module.exports = __webpack_public_path__ + "img/lia.a4525a6f.jpeg";